import React from 'react';
import { money } from '../../utils/helpers';
import { lineBasisText, lineCountText, lineRangeText } from '../../utils/costLines';

// Read-only table of a booking's lines, each with its live numbers.
// `lines` carry `m` = lineMath(line, count) (useExpenses / useServiceDetail).
export default function CostLinesBreakdownDesktop({ lines, fnName }) {
  if (!lines || !lines.length) return null;
  return (
    <table className="tbl compact mn-breakdown">
      <thead><tr><th>Item</th><th>Function</th><th>How</th><th>Count</th><th className="mn-r">Amount</th></tr></thead>
      <tbody>
        {lines.map(l => {
          const countText = lineCountText(l, l.m);
          return (
            <tr key={l.CostLineId}>
              <td>{l.Title}{l.Category && <span className="muted"> · {l.Category}</span>}</td>
              <td>{l.FunctionId ? fnName(l.FunctionId) : 'Whole event'}</td>
              <td>{lineBasisText(l, l.m, money)}</td>
              <td className={l.m.gap > 0 && l.ChargeRule === 'Booked' && l.m.booked > 0 ? 'mn-due' : 'muted'}>
                {[countText, lineRangeText(l, l.m, money)].filter(Boolean).join(' · ')}
              </td>
              {/* An "if needed" line is greyed: it is listed, it is not owed. */}
              <td className={'mn-r' + (l.m.optional ? ' muted' : '')}>{money(l.m.optional ? l.m.maxAmount : l.m.amount)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
